/**
 * GA4 storefront tracking for Dawn.
 * Meta Pixel stays on Shopify's web pixel — do not init fbq here.
 */
(function () {
  const measurementId = window.ENNAMORE_GA_ID;
  if (!measurementId || typeof measurementId !== 'string') return;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = window.gtag || gtag;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
  document.head.appendChild(script);

  gtag('js', new Date());
  gtag('config', measurementId, { send_page_view: true });

  function money(amount) {
    const n = Number(amount);
    return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0;
  }

  function track(name, params) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, params || {});
  }

  function trackViewItem() {
    const el = document.querySelector('[data-ennamore-analytics-product]');
    if (!el) return;
    const id = el.getAttribute('data-variant-id') || el.getAttribute('data-product-id');
    if (!id) return;
    track('view_item', {
      currency: el.getAttribute('data-currency') || 'USD',
      value: money(el.getAttribute('data-price')),
      items: [
        {
          item_id: id,
          item_name: el.getAttribute('data-product-title') || document.title,
          item_variant: el.getAttribute('data-variant-title') || undefined,
          price: money(el.getAttribute('data-price')),
          quantity: 1,
        },
      ],
    });
  }

  function itemFromCartLine(line) {
    if (!line) return null;
    const id = String(line.variant_id || line.id || '');
    if (!id) return null;
    const qty = Number(line.quantity) || 1;
    const price = money(
      line.final_price != null ? line.final_price / 100 : line.price != null ? line.price / 100 : 0
    );
    return {
      item_id: id,
      item_name: line.product_title || line.title,
      item_variant: line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : undefined,
      price,
      quantity: qty,
    };
  }

  function trackAddToCartFromPubSub(event) {
    const cartData = event?.cartData;
    if (!cartData) return;

    // product-form publishes the /cart/add.js line item as cartData
    let items = [];
    if (cartData.items && Array.isArray(cartData.items)) {
      items = cartData.items.map(itemFromCartLine).filter(Boolean);
    } else if (cartData.variant_id || cartData.id) {
      const one = itemFromCartLine(cartData);
      if (one) items = [one];
    }

    if (!items.length) return;
    const currency = cartData.currency || document.querySelector('[data-ennamore-analytics-product]')?.getAttribute('data-currency') || 'USD';
    const value = items.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0);
    track('add_to_cart', { currency, value: money(value), items });
  }

  function trackBeginCheckout() {
    const checkoutLinks = document.querySelectorAll('form[action*="/cart"] [name="checkout"], [name="checkout"], a[href*="/checkout"]');
    checkoutLinks.forEach((el) => {
      if (el.dataset.ennamoreGaBound) return;
      el.dataset.ennamoreGaBound = '1';
      el.addEventListener('click', () => {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            const items = (cart.items || []).map(itemFromCartLine).filter(Boolean);
            track('begin_checkout', {
              currency: cart.currency || 'USD',
              value: money((cart.total_price || 0) / 100),
              items,
            });
          })
          .catch(() => {});
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    trackViewItem();
    trackBeginCheckout();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source === 'product-form' || event?.source === 'quick-add') {
          trackAddToCartFromPubSub(event);
        }
        // Re-bind checkout buttons after cart drawer re-renders
        setTimeout(trackBeginCheckout, 300);
      });
    }
  });
})();
